import axios from "axios";

const state = () => ({
  marcas: [],
  loder: true,
});

const getters = {
  marcas(state) {
    return state.marcas;
  },
  loder(state) {
    return state.loder;
  },
};

const mutations = {
  setData(state, payload) {
    state[payload.key] = payload.value;
    state.loder = false;
  },
  SET_LODER_MARCAS(state, payload) {
    state.loder = payload;
  },
};

const actions = {
  getMarcas({ commit }) {
    return new Promise(async (resolve, reject) => {
      commit("SET_LODER_MARCAS", true);
      try {
        const r = await axios.get(process.env.VUE_APP_BASE_URL + "productos/marcas");
        commit("setData", { key: "marcas", value: r.data });
        resolve();
      } catch (e) {
        commit("SET_LODER_MARCAS", false);
        reject(e);
      }
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
